import { graphql } from '../../gql';

export const TAXONOMY_VERSIONS_QUERY = graphql(`
  query TaxonomyVersions($taxonomyType: TaxonomyType!) {
    taxonomyVersions(req: { taxonomy_type: $taxonomyType }) {
      versions
    }
  }
`);

export const TAXONOMY_LATEST_VERSION_QUERY = graphql(`
  query TaxonomyLatestVersion($taxonomyType: TaxonomyType!) {
    taxonomyLatestVersion(req: { taxonomy_type: $taxonomyType }) {
      version
    }
  }
`);

export const TAXONOMY_LIST_QUERY = graphql(`
  query TaxonomyList($taxonomyType: TaxonomyType!, $taxonomyVersion: String) {
    taxonomyList(
      req: { taxonomy_type: $taxonomyType, taxonomy_version: $taxonomyVersion }
    ) {
      taxonomies {
        id
        name
        version
      }
    }
  }
`);

export const TAXONOMY_TREE_QUERY = graphql(`
  query TaxonomyTree(
    $taxonomyType: TaxonomyType!
    $taxonomyId: Int!
    $taxonomyVersion: String
    $levels: [Int!]
    $includeTitles: Boolean!
  ) {
    taxonomy(
      req: {
        taxonomy_type: $taxonomyType
        taxonomy_id: $taxonomyId
        taxonomy_version: $taxonomyVersion
        levels: $levels
      }
    ) {
      levels {
        id
        tag
        label
      }
      nodes {
        ...TaxonomyNodeFields
        children {
          ...TaxonomyNodeFields
          children {
            ...TaxonomyNodeFields
            children {
              ...TaxonomyNodeFields
              children {
                ...TaxonomyNodeFields
                children {
                  ...TaxonomyNodeFields
                  children {
                    ...TaxonomyNodeFields
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  fragment TaxonomyNodeFields on TaxonomyNode {
    id
    name
    count
    titles @include(if: $includeTitles)
  }
`);
